import { createContext, PropsWithChildren, useContext } from 'react'

import MainLoader from '@components/MainLoader/MainLoader'
import AuthUtils from '@utils/AuthUtils'

export const BepAuthContext = createContext(undefined)

type Props = {
	children: React.ReactNode
}

export default function BepAuthenticationProvider({ children }: PropsWithChildren<Props>) {
	// const [tokens, setTokens] = useState(null)
	// const { showBoundary } = useErrorBoundary()

	// useEffect(() => {
	// 	if (AuthUtils.getRefreshToken() && AuthUtils.getAccessToken()) {
	// 		setTokens({
	// 			accessToken: AuthUtils.getAccessToken(),
	// 			refreshToken: AuthUtils.getRefreshToken(),
	// 			role: AuthUtils.getRole(),
	// 		})
	// 	}

	// async function login() {
	// 	setTokens(null)
	// 	try {
	// 		await AuthUtils.bepLogin()
	// 		const tokens = await AuthUtils.refreshBepToken()
	// 		setTokens(tokens)
	// 	} catch (error) {
	// 		showBoundary(error)
	// 	}
	// }

	// async function refresh() {
	// 	setTokens(null)
	// 	try {
	// 		const response = await AuthUtils.refreshBepToken()
	// 		if (!response.success && response.message === 'Refresh token expired') {
	// 			login()
	// 			return
	// 		}
	// 		if (!response.success && response.message === 'Login expired') {
	// 			login()
	// 			return
	// 		}

	// 		setTokens(response)
	// 	} catch (error) {
	// 		showBoundary(error)
	// 	}
	// }

	// 	if (!AuthUtils.getRefreshToken()) {
	// 		login()
	// 		return
	// 	}

	// 	refresh()
	// }, [showBoundary])

	// const contextValue = useMemo(() => ({ isAdmin: tokens?.role === 'admin' }), [tokens])

	if (AuthUtils.getSsoToken()) {
		return <BepAuthContext.Provider value={null}>{children}</BepAuthContext.Provider>
	}

	return <MainLoader />
}

export const useBepAuth = () => {
	if (!BepAuthContext) throw new Error('useBepAuth must be used within a BepAuthenticationProvider')
	return useContext(BepAuthContext)
}
